import { Reveal, SectionHead } from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { waLink } from "@/lib/site";

const PROJECTS = [
  ["Corporate Business", "Meridian Corporate", "A sharp corporate presence built for credibility and lead generation.", "/assets/portfolio-corporate.webp"],
  ["Restaurant", "Saffron Table", "Menu, gallery, reservations and WhatsApp ordering enquiries.", "/assets/portfolio-restaurant.webp"],
  ["Hotel", "Azure Grand Hotel", "Rooms, amenities, gallery and booking enquiry experience.", "/assets/portfolio-hotel.webp"],
  ["Salon", "Luxe Locks Salon", "Services, pricing, gallery and appointment enquiries.", "/assets/portfolio-salon.webp"],
  ["Clinic", "CarePoint Clinic", "Specialities, doctors and patient enquiry flows.", "/assets/portfolio-clinic.webp"],
  ["Real Estate", "Skyline Estates", "Property listings, galleries and lead capture.", "/assets/portfolio-real-estate.webp"],
  ["Used Cars", "PrimeDrive Motors", "Vehicle listings with test-drive and WhatsApp enquiries.", "/assets/portfolio-used-cars.webp"],
  ["E-Commerce", "UrbanKart Store", "Product showcase built to convert browsers into buyers.", "/assets/portfolio-ecommerce.webp"],
  ["Startup", "Nexovate", "A bold product story for a fast-moving startup.", "/assets/portfolio-startup.webp"],
  ["Local Business", "CityCare Services", "Service areas, trust signals and instant contact options.", "/assets/portfolio-local-business.webp"],
];

export const Portfolio = () => (
  <section id="work" data-testid="portfolio-section" className="relative bg-ink py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHead
        eyebrow="Our work"
        title="Designed for different businesses. Built around their goals."
        sub="A look at the kind of premium web experiences we create across industries."
      />
      <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {PROJECTS.map(([cat, name, desc, img], i) => (
          <Reveal key={name} delay={(i % 3) * 0.08}>
            <div className="group" data-testid={`portfolio-card-${i}`}>
              <div className="relative aspect-video overflow-hidden rounded-xl border border-white/5 transition-[box-shadow,transform,border-color] duration-500 group-hover:-translate-y-1.5 group-hover:border-accent/30 group-hover:shadow-[0_0_40px_rgba(0,229,255,0.12)]">
                <img
                  src={img}
                  alt={`${name} — ${cat} website by Falkeen Technologies`}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                <a
                  href={waLink(`Hi Falkeen Technologies, I saw the ${name} concept in your portfolio. I'd like something similar for my ${cat.toLowerCase()} business.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`portfolio-view-${i}`}
                  className="absolute inset-0 flex items-end justify-between bg-gradient-to-t from-black/85 via-black/20 to-transparent p-5 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                >
                  <span className="font-display text-xs font-bold uppercase tracking-[0.2em] text-white">View Project</span>
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent text-ink">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </a>
              </div>
              <p className="mt-4 font-display text-[10px] font-bold uppercase tracking-[0.25em] text-accent">{cat}</p>
              <h3 className="mt-1 font-display text-lg font-extrabold tracking-tight text-white">{name}</h3>
              <p className="mt-1 text-sm text-zinc-500">{desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
